/**
 * A normalised error for any failed API call. Services throw this so callers
 * (hooks, components) can branch on `status` / `code` instead of parsing raw
 * responses. See `lib/httpClient` for where it is constructed.
 */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details?: unknown;

  constructor(message: string, status: number, code = "api_error", details?: unknown) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.details = details;
  }

  /** True when the user is not authenticated (server redirects / 401s). */
  get isUnauthorized(): boolean {
    return this.status === 401 || this.status === 403;
  }
}
